import { TFunc } from 'libs/i18n';
import { ClientsListItem } from 'modules/client/clients/types';
import { renderClientStatus } from 'modules/client/common/helpers';

export const renderStatus = (item: ClientsListItem, t: TFunc) =>
  renderClientStatus({ ...item, status: item.onboardingStatus }, t, {
    size: 'm',
  });
